/**
 * Whether an addon group takes one answer or several — the difference between a
 * radio and a checkbox, and between "Pick one" and "Pick at least two".
 *
 * Set on the menu, so it arrives with the menu payload and is never chosen here.
 */
const ADDON_GROUP_TYPE = {
  SINGLE: 'single',
  MULTIPLE: 'multiple'
} as const

type AddonGroupType = (typeof ADDON_GROUP_TYPE)[keyof typeof ADDON_GROUP_TYPE]

export { ADDON_GROUP_TYPE }
export type { AddonGroupType }
